import React from "react";
import ProductsMainspage from '../components/Products/Productmain';

const ProductsMain = () =>{
    return(
        <>
        <ProductsMainspage />
        </>
    )
};

export default ProductsMain;